<template>
    <UISimple @click="toggleMockData">
        <template #title>
            Demo data
        </template>
        <template #right-content>
            <DSwitch
                :model-value="mockData"
                class="pointer-events-none"
            />
        </template>
    </UISimple>
</template>

<script setup>
    import { DSwitch } from '@digistorm/spark'

    const appStore = useAppStore()

    const { mockData } = storeToRefs(appStore)

    const toggleMockData = () => {
        if (mockData.value) {
            appStore.disableMockData()
        } else {
            appStore.enableMockData()
        }
    }
</script>
